import { useEffect, useRef, useState } from "react";
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
export const CustomPlayer = ({ src, poster, title, description, isCentered=true, locale, lang }) => {
  const pauseRef = useRef();
  const playRef = useRef();
  const videoRef = useRef();
  const cursorRef = useRef();
  const videoInterval = useRef();

  const [videoTime, setVideoTime] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    gsap.set(".animate-top",{
        opacity: 0,
        y: 100
    })
    ScrollTrigger.batch(".animate-top", {
        onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.2}, overwrite: true}),
        onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.2, overwrite: true}),
    });
  }, []);

  return (
    <div
      className="relative w-full v-md:w-[47%] h-full aspect-[1.63] animate-top group"
      onDoubleClick={() => videoRef.current.requestFullscreen()}
    >
      <video
        className="w-full h-full object-cover"
        ref={videoRef}
        src={src}
        poster={poster}
        preload={false}
        aria-label={title || "Video player"}
      >
        <track kind="captions" />
      </video>
      <div className="controls absolute bottom-0 w-full p-6 gap-4 hidden" ref={playRef}>
        <img
          onClick={() => {
            playRef.current.classList.add("hidden");
            playRef.current.classList.remove("flex");
            pauseRef.current.classList.remove("hidden");
            videoRef.current.pause();
            clearInterval(videoInterval.current);
          }}
          alt=""
          src="/pausebutton.svg"
          aria-hidden="true"
          className="pauseButton w-[25%] min-w-[60px] max-w-[70px] aspect-square hover:cursor-pointer"
        />
        <div className="relative w-full flex justify-between h-0.5 rounded-full self-center hover:cursor-pointer bg-white text-white">
          <div
            className="absolute h-2.5 w-2.5 rounded-full -translate-y-2/4 bg-white"
            ref={cursorRef}
          ></div>

          <div> {~~(currentTime / 60) + ":" + ("0" + ~~(currentTime % 60)).slice(-2)}</div>
          <div> {~~(videoTime / 60) + ":" + ("0" + ~~(videoTime % 60)).slice(-2)}</div>
        </div>
      </div>
      <div
        className={`controls absolute flex bottom-0 w-full p-6 pr-4 
        bg-gradient-to-t from-[#0000009d] lg:opacity-0 lg:group-hover:opacity-100 transition-all duration-500
        ${isCentered ? "justify-between " : "top-0 justify-center items-center"}`}
        ref={pauseRef}
      >
        {isCentered && (<div className=" flex flex-col gap-y-4 ">
          <h2 className=" text-4brand md:text-[30px] 2xl:text-3brand text-white font-medium ">{title}</h2>
          <p className=" text-white pr-4 text-5brand 2xl:text-4brand">{description}</p>
        </div>)}
        <img
          onClick={() => {
            playRef.current.classList.remove("hidden");
            playRef.current.classList.add("flex");
            pauseRef.current.classList.add("hidden");
            videoRef.current.play();
            setVideoTime(videoRef.current.duration);
            videoInterval.current =
              mounted &&
              window.setInterval(() => {
                setCurrentTime(videoRef.current?.currentTime);
                const duration = videoRef.current?.duration;
                const current = videoRef.current?.currentTime;
                if(cursorRef.current){
                  cursorRef.current.style.left = (current / duration) * 100 + "%";
                }else{
                  clearInterval(videoInterval.current);
                }
              }, 1000);
          }}
          alt=""
          src="/playbutton.svg"
          aria-hidden="true"
          className={`playbutton w-[25%] min-w-[60px] max-w-[70px]
           aspect-square hover:cursor-pointer ${isCentered ? "self-end":""}`}
        />
      </div>
    </div>
  );
};

